import React from 'react';
import { Link } from 'react-router-dom';

import FlexibilityIcon from './Flexibility.svg';
import MonthlyUsersIcon from './MonthlyUsers.svg';
import PageViewsIcon from './PageViews.svg';
import ReachIcon from './Reach.svg';
import Button from 'Components/Button';

const AdvertiseText = () => {
  return (
    <div className="GenericText__content">
      <h1 style={{ fontSize: '3em', margin: 0 }}>Advertise with Funbrain</h1>
      <p style={{ marginBottom: '1em' }}>
        For advertising inquiries, contact us at{' '}
        <a href="mailto:help@funbrain.com">help@funbrain.com</a>:
      </p>
      <p style={{ marginBottom: '3em', width: '11em' }}>
        <Button
          text="Contact Us"
          buttonSize="hero"
          mediaType="games"
          withAction
          externalLink="mailto:help@funbrain.com"
        />
      </p>

      <h2>Why Funbrain?</h2>
      <p>
        <ul className="GenericText__content-grid">
          <li className="GenericText__content-item">
            <ReachIcon />
            <p>Reach</p>
            <p className="GenericText__content-item__subtitle">
              Millions of students
            </p>
          </li>
          <li className="GenericText__content-item">
            <MonthlyUsersIcon />
            <p>10+ Million</p>
            <p className="GenericText__content-item__subtitle">
              Monthly Pageviews
            </p>
          </li>
          <li className="GenericText__content-item">
            <div style={{ position: 'relative', top: -5 }}>
              <PageViewsIcon />
            </div>
            <p>600K</p>
            <p className="GenericText__content-item__subtitle">Monthly Users</p>
          </li>
          <li className="GenericText__content-item">
            <div style={{ position: 'relative', top: -5 }}>
              <FlexibilityIcon />
            </div>
            <p>Flexibility</p>
            <p className="GenericText__content-item__subtitle">
              Banners + Takeovers
            </p>
          </li>
        </ul>
      </p>
      <h2>Custom Options</h2>
      <p>
        Owning the Funbrain homepage to maximize visibility, a page takeover,
        and standard ad units are all options based on your needs. The Funbrain
        site is responsive so your ads will have eyeballs on them whether our
        users are on desktop, mobile, or tablet.
      </p>
      <h2>The Funbrain Audience</h2>
      <p>
        Funbrain is a fun and safe environment that bridges learning and
        entertainment. Since 1997, Funbrain has been used by kids (preschool-8th
        grade) in classrooms, schools, and homes across the USA and Canada.
      </p>
      <h2>The Funbrain Experience</h2>
      <p>
        Funbrain is always adding new interactive content with games, books,
        videos, series, and worksheets to support what kids are learning in
        school.
      </p>
    </div>
  );
};

export default AdvertiseText;
